import React from "react";
import Tooltip from "@mui/material/Tooltip";

const ProfileStep = ({
  step,
  complete = true,
  missingFields = [],
  dirty = false,
  active = false,
  optional = false,
  onClick,
}) => {
  const tooltipTitle = dirty ? (
    <span style={{ color: "#fff" }}>You have unsaved changes — click Save to apply.</span>
  ) : !complete && missingFields.length > 0 ? (
    <div style={{ color: "#fff" }}>
      <p style={{ color: "#fff", fontWeight: 500, marginBottom: 4 }}>Missing details:</p>
      <ul style={{ color: "#fff", listStyleType: "disc", paddingLeft: 16, margin: 0 }}>
        {missingFields.map((field) => (
          <li key={field} style={{ color: "#fff" }}>
            {field}
          </li>
        ))}
      </ul>
    </div>
  ) : (
    ""
  );

  // Unsaved edits take visual priority over the saved-completion state.
  const circleClass = dirty ? "bg-amber-100" : complete ? "bg-primary/35" : "bg-gray-200";
  const iconClass = dirty
    ? "fa-solid fa-pen text-amber-500 text-sm"
    : complete
      ? "fa-solid fa-circle-check text-primary text-xl"
      : "fa-regular fa-circle text-gray-400 text-xl";

  return (
    <Tooltip
      title={tooltipTitle}
      arrow
      placement="right"
      disableHoverListener={!tooltipTitle}
      slotProps={{
        popper: { sx: { zIndex: 1500 } },
        tooltip: {
          sx: {
            bgcolor: "#1f2937",
            color: "#fff",
            fontSize: 13,
            maxWidth: 260,
            p: 1.25,
            "& .MuiTooltip-arrow": { color: "#1f2937" },
          },
        },
      }}
    >
      <div className="inline mb-[15px]">
        <div
          role="button"
          tabIndex={0}
          onClick={onClick}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") onClick?.();
          }}
          className={`flex items-center bg-white py-[12px] xl:px-8 px-4 rounded-xl cursor-pointer transition-shadow hover:shadow-md ${
            active ? "ring-2 ring-primary" : ""
          }`}
        >
          <div className={`flex items-center justify-center rounded-full h-7 w-7 ${circleClass}`}>
            <i className={iconClass}></i>
          </div>

          <h6 className="text-primary font-normal ml-5 text-base">{step}</h6>
          {optional && (
            <span className="ml-2 text-xs font-normal text-gray-500 bg-gray-100 rounded-full px-2 py-[2px]">
              Optional
            </span>
          )}
        </div>
      </div>
    </Tooltip>
  );
};

export default ProfileStep;
